import { render, staticRenderFns } from "./AppBreadcrumbsItem.vue?vue&type=template&id=197284bb&"
import script from "./AppBreadcrumbsItem.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumbsItem.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadcrumbsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports